import {
  GenericKeyResponseDto,
  KeyEntityResponseDto,
} from '../../api/kmsapiclient'
import { KeyInfo } from '../../components/common/types'
import { Keys } from '../reducers/initialState'

import {
  BaseActionType,
  DELETE_KEY_SUCCESS,
  LOAD_KEYS_SUCCESS,
  LOAD_MORE_KEYS_SUCCESS,
  UPDATE_KEY_SUCCESS,
  UPLOAD_KEYS_SUCCESS,
} from './actionTypes'

export const loadKeysSuccess = (keys: Keys): BaseActionType => ({
  type: LOAD_KEYS_SUCCESS,
  payload: keys,
})

export const loadMoreKeysSuccess = (keys: Keys): BaseActionType => ({
  type: LOAD_MORE_KEYS_SUCCESS,
  payload: keys,
})

export const updateKeySuccess = (
  key: KeyEntityResponseDto,
): BaseActionType => ({
  type: UPDATE_KEY_SUCCESS,
  payload: key,
})

export const deleteKeySuccess = (key: KeyInfo): BaseActionType => ({
  type: DELETE_KEY_SUCCESS,
  payload: key,
})

export const addKeySuccess = (key: GenericKeyResponseDto): BaseActionType => ({
  type: UPLOAD_KEYS_SUCCESS,
  payload: key,
})
